import { Sucursal } from '../sucursal/sucursal';
export class Gateway {
	_id: string;
	url: string;
	puerto: Number;
	etiqueta: string;
	descripcion: string;
	pass: string;
	sucursal_id: Sucursal;
	estado: Boolean;
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/gateway/gateway.ts